import * as z from "zod";
import type { WithdrawalListItem } from "./list-withdrawals";
import { withdrawalListItemSchema } from "./list-withdrawals";

const getWithdrawalInput_ = z.union([
  z.object({ withdrawalId: z.string() }),
  z.object({ returnId: z.string() }),
]);
export const getWithdrawalInput: z.ZodType<GetWithdrawalInput> =
  getWithdrawalInput_;
export type GetWithdrawalInput = z.infer<typeof getWithdrawalInput_>;

const withdrawalDetailItemSchema_ = z.object({
  lineItemId: z.string(),
  imageSrc: z.string().nullable(),
  title: z.string(),
  variantTitle: z.string().nullable(),
  quantity: z.number(),
  formattedPrice: z.string().nullable(),
  eligible: z.boolean().nullable(),
});
export const withdrawalDetailItemSchema: z.ZodType<WithdrawalDetailItem> =
  withdrawalDetailItemSchema_;
export interface WithdrawalDetailItem extends z.infer<
  typeof withdrawalDetailItemSchema_
> {}

const withdrawalTimelineEventActorSchema_ = z.object({
  name: z.string(),
  email: z.string(),
});
export interface WithdrawalTimelineEventActor extends z.infer<
  typeof withdrawalTimelineEventActorSchema_
> {}

const withdrawalTimelineEventSchema_ = z.object({
  id: z.string(),
  withdrawalId: z.string(),
  message: z.string(),
  createdAt: z.date(),
  isSystem: z.boolean(),
  actorUserId: z.string().nullable(),
  actor: withdrawalTimelineEventActorSchema_.nullable(),
});
export const withdrawalTimelineEventSchema: z.ZodType<WithdrawalTimelineEvent> =
  withdrawalTimelineEventSchema_;
export interface WithdrawalTimelineEvent extends z.infer<
  typeof withdrawalTimelineEventSchema_
> {}

const withdrawalDetailSchema_ = withdrawalListItemSchema.and(
  z.object({ timeline: z.array(withdrawalTimelineEventSchema_) }),
);
export const withdrawalDetailSchema: z.ZodType<WithdrawalDetail> =
  withdrawalDetailSchema_;
export interface WithdrawalDetail extends WithdrawalListItem {
  timeline: WithdrawalTimelineEvent[];
}

const getWithdrawalOutput_ = z.object({
  withdrawal: withdrawalDetailSchema,
  items: z.array(withdrawalDetailItemSchema_),
});
export const getWithdrawalOutput: z.ZodType<GetWithdrawalOutput> =
  getWithdrawalOutput_;
export interface GetWithdrawalOutput extends z.infer<
  typeof getWithdrawalOutput_
> {}

export const getWithdrawal = {
  name: "getWithdrawal" as const,
  input: getWithdrawalInput,
  output: getWithdrawalOutput,
};
